"use client";

import { useActionState } from "react";
import Link from "next/link";
import { requestPasswordResetAction, resetPasswordAction } from "@/app/actions/auth";

const inputClass =
  "w-full rounded-xl border border-white/10 bg-slate-950 px-3 py-2.5 text-sm text-white outline-none focus:border-teal-400 focus:ring-2 focus:ring-teal-400/40";

export function ForgotPasswordForm() {
  const [state, formAction, pending] = useActionState(requestPasswordResetAction, null);
  return (
    <form action={formAction} className="space-y-4">
      <label className="block">
        <span className="mb-1.5 block text-sm font-medium text-slate-300">Email</span>
        <input name="email" type="email" required autoComplete="email" className={inputClass} />
      </label>
      {state?.error ? (
        <p className="rounded-xl bg-rose-500/15 px-3 py-2 text-sm text-rose-300">{state.error}</p>
      ) : null}
      <button
        type="submit"
        disabled={pending}
        className="w-full rounded-xl bg-teal-400 py-2.5 text-sm font-semibold text-slate-950 hover:bg-teal-300 disabled:opacity-60"
      >
        {pending ? "Mengirim..." : "Kirim tautan reset"}
      </button>
      <p className="text-center text-sm text-slate-400">
        Ingat password?{" "}
        <Link href="/login" className="font-medium text-teal-300">
          Masuk
        </Link>
      </p>
    </form>
  );
}

export function ResetPasswordForm({ token }: { token: string }) {
  const [state, formAction, pending] = useActionState(resetPasswordAction, null);
  return (
    <form action={formAction} className="space-y-4">
      <input type="hidden" name="token" value={token} />
      <label className="block">
        <span className="mb-1.5 block text-sm font-medium text-slate-300">Password baru</span>
        <input
          name="password"
          type="password"
          required
          minLength={6}
          autoComplete="new-password"
          className={inputClass}
        />
      </label>
      <label className="block">
        <span className="mb-1.5 block text-sm font-medium text-slate-300">Ulangi password</span>
        <input
          name="confirm"
          type="password"
          required
          minLength={6}
          autoComplete="new-password"
          className={inputClass}
        />
      </label>
      {state?.error ? (
        <p className="rounded-xl bg-rose-500/15 px-3 py-2 text-sm text-rose-300">{state.error}</p>
      ) : null}
      <button
        type="submit"
        disabled={pending}
        className="w-full rounded-xl bg-teal-400 py-2.5 text-sm font-semibold text-slate-950 hover:bg-teal-300 disabled:opacity-60"
      >
        {pending ? "Menyimpan..." : "Simpan password baru"}
      </button>
      <p className="text-center text-sm text-slate-400">
        Tautan tidak berlaku?{" "}
        <Link href="/lupa-password" className="font-medium text-teal-300">
          Minta tautan baru
        </Link>
      </p>
    </form>
  );
}
